__turbopack_context__.v({
  "assetPageLayout": "layout-module__yd_Hwa__assetPageLayout",
});
